import glamorous from 'glamorous';

// tslint:disable-next-line: no-any
export const AgGridStyle = glamorous.div<{ theme?: any }>((props) => ({
    position: 'relative',
    height: '100%',
    width: '100%',
    fontFamily: 'Nunito !important',
    flex: 1,
    '@media (max-width: 959.95px)': {
        height: '500px!important',
    },
    '& .ag-column-tool-panel-column': {
        fontFamily: 'Roboto, sans-serif',
    },
    // '& .ag-icon-checkbox-indeterminate': {
    //     display: 'none !important',
    // },
    '& .ag-header': {
        border: 'none !important',
        boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
    },
    '& .ag-cell-value': {
        fontSize: '14px !important',
    },
    [`& .${`ag-root-wrapper-body`}`]: {
        // display: 'flex',
        // justifyContent: 'center'
    },
    [`& .${`grid-container`}`]: {
        // height: window.innerHeight - 440,
        [`.${`print`}`]: {
            height: 'auto !important'
        },
        [`& .${`ag-tool-panel`}`]: {
            [`& .${`ag-side-buttons`}`]: {
                display: 'none'
            }
        }
    },
    [`& .${`hideGroupPanel`}`]: {
        [`& .${`ag-column-drop-row-group`}`]: {
            display: 'none'
        }
    },
    [`& .${`showGroupPanel`}`]: {
        [`& .${`ag-column-drop-row-group`}`]: {
            display: 'flex',
            '& .ag-faded': {
                color: '#000 !important',
                opacity: '1 !important',
            }
        }
    },
    [`& .${`ag-bl-normal`}`]: {
        textAlign: 'left',
        width: '100%',
    },
    [`& .${`ag-body-viewport-wrapper`}`]: {
        color: props.theme.BrandColors.TextSecondary,
        fontFamily: props.theme.Font.Main,
        fontSize: '14px'
    },
    [`& .${`ag-header-viewport`}`]: {
        backgroundColor: props.theme.NeutralColors.LightBlue2
    },
    [`& .${`ag-column-drop`}`]: {

    },
    [`& .${`ag-column-drop-row-group`}`]: {
        borderBottom: 0,
        backgroundColor: props.theme.NeutralColors.LightGrey1,
        color: props.theme.BrandColors.TemplatePrimary,
    },
    [`& .${`ag-header-row`}`]: {
        borderBottom: 'none !important',
        color: props.theme.BrandColors.TextPrimary,
    },
    [`& .${`ag-header-cell`}`]: {
        lineHeight: '40px !important',
        padding: '0px 15px !important',
        backgroundColor: `inherit !important`,
    },
    [`& .${`ag-icon-menu`}`]: {
        // height: '40px !important',
    },
    [`& .${`ag-header-cell-label`}`]: {
        fontSize: '14px',
        fontWeight: props.theme.FontWeight.SixHundred,
        // padding: '0 15px',
        fontFamily: props.theme.Font.Main
    },
    [`& .${`ag-column-drop-icon`}`]: {
        color: props.theme.BrandColors.TemplatePrimary,
    },
    [`& .${`ag-row`}`]: {
        borderBottom: '1px solid rgba(0,0,0,0.05) !important',
        transition: 'background-color 0.15s ease, box-shadow 0.15s ease',
    },
    [`& .${`ag-row-odd`}`]: {
        backgroundColor: 'rgba(81,115,255,0.03) !important',
    },
    [`& .${`ag-row-even`}`]: {
        backgroundColor: '#FFFFFF !important',
    },
    [`& .${`ag-cell`}`]: {
        padding: '0 15px !important'
    },
    [`& .${`ag-header-cell-resize`}`]: {
        '::after': {
            marginTop: '8px !important',
        }
    },
    [`& .${`ag-tab`}`]: {
        backgroundColor: props.theme.NeutralColors.LightGrey1
    },
    [`& .${`ag-tab-selected`}`]: {
        borderBottom: '2px solid ' + props.theme.BrandColors.TemplatePrimary
    },
    [`& .${`ag-row-hover`}`]: {
        backgroundColor: 'rgba(81,115,255,0.07) !important',
        color: props.theme.BrandColors.TemplatePrimary,
        boxShadow: 'inset 3px 0 0 #5173FF',
    },
    [`& .${`ag-overlay-loading-center`}`]: {
        padding: 10,
        backgroundColor: props.theme.NeutralColors.BackgroundWhite,
        color: props.theme.BrandColors.TemplatePrimary,
        border: '1px solid ' + props.theme.BrandColors.TemplatePrimary,
        borderRadius: '.28571429rem !important',
    },
    [`& .${`ag-full-width-row`}`]: {
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        [`& .${`ag-loading-text`}`]: {
            color: props.theme.BrandColors.TemplatePrimary,
            margin: '0px !important'
        },
        [`& .${`ag-loading-icon`}`]: {
            color: props.theme.BrandColors.TemplatePrimary,
        }
    },
    [`& .${`ag-react-container`}`]: {
        // display: 'inline-block',
        width: '100%',
        height: '100%',
        overflow: 'hidden'
    },     
    '& .ag-icon-checkbox-checked': {
        color: '#5173FF !important'
    },
    '& .ag-icon-checkbox-indeterminate': {
        color: '#5173FF !important'
    },
    '& .ag-center-cols-viewport': {
        overflowX: 'hidden'
    },
    '& .draft-timesheet-row': {
        color: 'orange'
    },
    '& .ag-header-cell-center': {
        '& .ag-header-cell-label': {
            justifyContent: 'center'
        }
    },
    '& .invalid-row': {
        color: 'red !important'
    },
    '& .invalid-cell': {
        backgroundColor: 'rgba(255, 0, 0, 0.7) !important' // 
    }
}));

// tslint:disable-next-line: no-any
export const AgGridTableWrapper = glamorous.div<{ theme?: any }>((props) => ({
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    '& span[ref=eMenu]': {
        minWidth: '30px !important',
        '& .ag-icon-menu': {
            width: '100%'
        }
    },
    '& div[row-id=rowGroupFooter_ROOT_NODE_ID]': {
        '& .checkboxType': {
            display: 'none'
        }
    }
}));